import React, { memo } from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cn from 'classnames';

import Icon from '../Icon';

const PrivacyIcon = ({ show, className, intl }) => {
  const { formatMessage } = intl;

  return show ? (
    <span
      title={formatMessage({ id: 'common.onlyVisibleToYou' })}
      className={cn(className)}
    >
      <Icon size={16} name="icon-hide-password" />
    </span>
  ) : null;
};

PrivacyIcon.propTypes = {
  show: PropTypes.bool,
  className: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};

export default compose(
  injectIntl,
  memo,
)(PrivacyIcon);



// WEBPACK FOOTER //
// ./src/components/PrivacyIcon/index.jsx